<template>
  <Modal :title="title" @hide-modal="$emit('hide-modal')">
    <div
      v-if="quote.status === 'approved'"
      :class="{ 'signature-container': quote.signature.image_url }"
    >
      <img
        v-if="quote.signature.image_url"
        :src="quote.signature.image_url"
        alt="Signature"
      />
      <div v-else>Manually Approved</div>
    </div>
    <div v-else>
      <p v-if="quote.status === 'denied'" class="mb-4">
        This quote was denied, but as an admin you can manually approve it on
        behalf of the customer with reason.
      </p>
      <p v-else class="mb-4">
        This quote requires customer approval. As an admin you can manually
        approve the quote on behalf of the customer with reason.
      </p>
      <form @submit.prevent="handleApprove">
        <label class="full-width">
          Accept Reason
          <textarea
            v-model="approvalNote"
            class="form-control full-width"
            data-cy="quote-approval-modal"
          ></textarea>
        </label>
      </form>
    </div>
    <template #submit>
      <div v-if="quote.status === 'approved'"></div>
      <Button
        v-else
        :disabled="!approvalNote || saving"
        data-cy="modal-submit-btn"
        @click="handleApprove"
      >
        <span v-if="!saving">Accept Quote</span>
        <Spinner v-else message="Saving..."></Spinner>
      </Button>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Button from "@/components/Button.vue";
import Modal from "../../components/Modal.vue";
import Spinner from "../../components/Spinner.vue";

export default {
  components: {
    Modal,
    Spinner,
    Button
  },
  props: {
    quote: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal"],
  data() {
    return {
      approvalNote: "",
      saving: false
    };
  },
  computed: {
    title() {
      if (this.quote.status === "approved") {
        return "Quote Approved";
      } else if (this.quote.status === "denied") {
        return "Quote Denied";
      }
      return "Accept Quote";
    }
  },
  methods: {
    ...mapActions(["approveQuote", "setCurrentQuote", "setCurrentInvoice"]),
    handleApprove() {
      if (this.approvalNote) {
        this.saving = true;
        this.approveQuote({
          url: this.quote.links.quote_accept,
          note: this.approvalNote
        })
          .then(() => {
            this.saving = false;
            EventBus.$emit("refresh-quote-datatable");
            this.$emit("hide-modal");
            this.setCurrentQuote(null);
            this.setCurrentInvoice(null);
          })
          .catch(() => (this.saving = false));
      }
    }
  }
};
</script>
